// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'coa-custom-snackbar',
  templateUrl: './custom-snackbar.component.html',
  styleUrls: ['./custom-snackbar.component.scss'],
})
export class CustomSnackbarComponent implements OnInit {
  label: string;

  constructor(
    private router: Router,
    private matSnackBar: MatSnackBar,
    private activatedRoute: ActivatedRoute,
    @Inject(MAT_SNACK_BAR_DATA) public data: { clientId: number, groupId: number, label: string },
  ) {
  }

  ngOnInit(): void {
    this.label = this.data.label;
  }

  redirect(): void {
    this.router.navigate(
      ['/clients',
        this.data.clientId,
        'groups',
        this.data.groupId,
      ], {
        queryParams: {
          dateRange: this.activatedRoute.snapshot.queryParams.dateRange,
        },
      });
    this.matSnackBar.dismiss();
  }

  close(): void {
    this.matSnackBar.dismiss();
  }
}
